// @flow

import {
    CLOSE_CONFIRMATION, OPEN_CONFIRMATION,
} from './constants';
import Proptypes from 'prop-types';

type UIAction = { type: string, payload: {} | string };

export const openConfirmation = (message: string, payload: Object, callback: Proptypes.func, negetive_callback?: Proptypes.func): UIAction => ({
    type: OPEN_CONFIRMATION,
    payload: {message, payload, callback, negetive_callback},
});

export const closeConfirmation = (): UIAction => ({
    type: CLOSE_CONFIRMATION,
    payload: {},
});
